<template>
  <div id="page-content-wrapper" class="login">
    <div class="container-fluid">
      <b-form @submit="onSubmit">
        <div class="contents">
          <div class="d-flex justify-content-center mt-2">
            <img src="/img/logo_black.png" alt="X-GOLF" />
          </div>
          <h3 class="montserrat my-4 text-center">{{ $t("page.login.admin_login") }}</h3>
          <!-- <label class="mb-2 d-block color-dgray">{{
            $t("title.common.id")
          }}</label> -->
          <input
            type="text"
            class="form-control form-control-lg mb-3"
            :placeholder="$t('title.common.id')"
            aria-label=""
            v-model="form.id"
          />
          <!-- <label class="mb-2 d-block color-dgray">{{
            $t("title.common.password")
          }}</label> -->
          <input
            type="password"
            class="form-control form-control-lg mb-3"
            :placeholder="$t('title.common.password')"
            aria-label=""
            v-model="form.password"
          />

          <input
            class="btn btn-primary btn-lg w-100 mb-3"
            type="submit"
            :value="$t('button.login.login')"
          />
          <!-- <span>당신의 IP 주소 : {{ ip }}</span> -->
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import ax from "@/api/auth";
import _ from "lodash";

export default {
  name: "Login",
  data() {
    return {
      form: {
        id: localStorage.getItem("remember_id") || "",
        password: "",
        rememberYn: !!localStorage.getItem("remember_yn"),
      },
      ip: null,
    };
  },
  created() {
    this.form = _.cloneDeep(this.form);
    this.showYourIP();
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      ax.getToken(this.form, (flag, msg) => {
        if (flag) {
          this.$router.push("/");
        } else {
          alert(msg);
        }
      });
    },
    resetForm() {
      this.form = _.cloneDeep(this.form);
    },
    showYourIP() {
      // fetch("https://api.ipify.org?format=json")
      //   .then((x) => x.json())
      //   .then(({ ip }) => {
      //     this.ip = ip;
      //   });
    },
  },
};
</script>